import type { ConnectionSummary } from '@debtbot/shared';
import { useT } from '../i18n';
import { peerDisplayName } from '../lib/connections';
import { formatRelativeDay, primaryBalance } from '../lib/format';
import { Amount } from './Amount';

export function PersonRow({ c, onClick }: { c: ConnectionSummary; onClick: () => void }) {
  const t = useT();
  const name = peerDisplayName(c);
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center justify-between gap-3 py-3 text-left active:opacity-70"
    >
      <div className="min-w-0">
        <div className="truncate text-base font-medium">{name}</div>
        <div className="truncate text-sm text-hint">
          {formatRelativeDay(c.last_activity_at)}
          {c.disputed.length > 0 && (
            <span className="ml-2 text-warning">⚠ {t.home.disputed(1)}</span>
          )}
        </div>
      </div>
      <Amount money={primaryBalance(c.balances)} className="shrink-0 text-base font-semibold" />
    </button>
  );
}
